// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"AnnotationStandards_tableContainer__3tb_j","addFindingType":"AnnotationStandards_addFindingType__y0tOU"};